import { render } from "./carfax-doc.vue?vue&type=template&id=ed46d7d4&scoped=true"
import script from "./carfax-doc.vue?vue&type=script&lang=js"
export * from "./carfax-doc.vue?vue&type=script&lang=js"

import "./carfax-doc.vue?vue&type=style&index=0&id=ed46d7d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed46d7d4"]])

export default __exports__